import { Divider, Grid, Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { RWrapper } from "../../../components/layout/RWrapper";
import DoNotDisturbForm from "./do-not-disturb-time-form";
import UserDetailsForm from "./user-details-form";

const PageTitleBox = styled.div`
  margin: ${({ theme }) => theme.gap[1]} 0;
`;

const SectionContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.paper};
  padding: ${({ theme }) => theme.gap[1]};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${({ theme }) => theme.shape.borderRadius};
  box-sizing: border-box;
  min-height: 50px;
`;

const SectionTitle = styled.div`
  font-size: ${({ theme }) => theme.fonts.size.default};
  color: ${({ theme }) => theme.colors.greyishBrown};
  display: flex;
  align-items: center;
`;

const Spacer = styled.div`
  height: ${({ theme }) => theme.gap[1]};
`;

function UserAccountScreen() {
  return (
    <RWrapper>
      <PageTitleBox>
        <Typography variant="h4" color="textPrimary">
          Account
        </Typography>
      </PageTitleBox>
      <Divider />
      <Spacer />
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <SectionContainer>
            <SectionTitle>Sms reminders</SectionTitle>
            <Spacer />
            <DoNotDisturbForm />
          </SectionContainer>
          <Spacer />
          <Divider />
          <Spacer />
          <SectionContainer>
            <SectionTitle>Contact Information</SectionTitle>
            <Spacer />
            <UserDetailsForm />
          </SectionContainer>
        </Grid>
      </Grid>
    </RWrapper>
  );
}

export default UserAccountScreen;
